import { render } from "./dialogSearchCustomer.vue?vue&type=template&id=39d2e6fa&scoped=true"
import script from "./dialogSearchCustomer.vue?vue&type=script&lang=js"
export * from "./dialogSearchCustomer.vue?vue&type=script&lang=js"

import "./dialogSearchCustomer.vue?vue&type=style&index=0&id=39d2e6fa&scoped=true&lang=css"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d2e6fa"]])

export default __exports__